import React from "react";
const LocalizedContentContext = React.createContext({});
const useLocalizedContent = () => React.useContext(LocalizedContentContext);
var LocalizedContentContext_default = LocalizedContentContext;
export {
  LocalizedContentContext_default as default,
  useLocalizedContent
};
